'use client';

import { type HTMLAttributes } from 'react';
import { Heading } from '@paypoteam/ui-components';

export interface H1Props extends HTMLAttributes<HTMLHeadingElement> {}

export default function H6({ children, ...props }: H1Props) {
    return (
        <Heading
            type="h6"
            size="xl"
            {...props}
        >
            {children}
        </Heading>
    );
}
